import React from "react";
import { Reveal, SectionHeading } from "@/components/common/Reveal";
import { useEnquiryForm } from "@/context/FormContext";
import { ArrowUpRight } from "lucide-react";

const CATEGORIES = [
  "AI-development companies", "Cloud providers", "Data & cybersecurity firms", "Marketing agencies", "Sales organisations",
  "Electronics manufacturers", "Contract manufacturers", "Industrial-design firms", "Machinery providers", "Packaging companies",
  "Logistics providers", "Research institutions", "Colleges & universities", "Incubators", "Chartered accountants",
  "Company secretaries", "Legal firms", "IP professionals", "Recruitment organisations", "Banks & NBFCs",
  "Angel networks", "Family offices", "Registered AIF managers", "Venture-capital firms",
];

export default function Partners() {
  const { openForm } = useEnquiryForm();
  return (
    <section id="partners" className="relative py-24 md:py-36 border-t border-white/5" data-testid="partners-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <SectionHeading label="Strategic-Partner Network" title="Build the AI economy with us." className="max-w-3xl" />
          <p className="mt-6 max-w-2xl text-base md:text-lg font-light text-zinc-400 leading-relaxed">
            We invite technology, manufacturing, marketing, professional-services and capital organisations to join an execution-focused AI ecosystem.
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-12 flex flex-wrap gap-2.5">
            {CATEGORIES.map((c) => (
              <span key={c} className="text-xs md:text-sm text-zinc-400 border border-white/8 rounded-full px-4 py-2 card-hover hover:border-white/25 hover:text-white">{c}</span>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <button onClick={() => openForm("partner")} className="group mt-12 inline-flex items-center gap-2 bg-[#0057FF] hover:bg-[#0047D6] text-white rounded-full px-7 py-3.5 font-medium transition-colors active:scale-[0.98]" data-testid="partners-cta">
            Become a Strategic Partner <ArrowUpRight className="h-4 w-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </button>
          <p className="mt-6 text-xs text-zinc-600 max-w-3xl leading-relaxed">Submitting a partnership application does not create an agency, partnership, joint venture, fiduciary relationship, exclusivity, representation authority or commercial obligation.</p>
        </Reveal>
      </div>
    </section>
  );
}
